import { Switch, Typography } from '@mui/material';
import { TreeList } from '@prismamedia/one-components';
import { ChangeEvent, FC, useCallback, useMemo } from 'react';
import { BrandKey } from '../../../../../../__generated__/queries-web';
import { useGetSources } from '../../../../../../apollo/queries/sources.web.graphql';
import { useStyles } from '../../styles';

const SOURCE_VOID = {
  id: '',
  label: 'Sans source',
};

export interface SourcesCheckboxesProps {
  brandKey: BrandKey;
  disabled?: boolean;
  onChange: (category: any) => void;
  value?: string[];
}

export const SourcesCheckboxes: FC<SourcesCheckboxesProps> = ({
  brandKey,
  disabled,
  onChange,
  value = [],
}) => {
  const classes = useStyles({ disabled });
  const { data } = useGetSources(brandKey);

  const sourcesTreeList = useMemo(() => {
    const newList =
      data?.sources.map(({ id, title: label }) => ({
        id,
        label,
      })) || [];

    return [SOURCE_VOID, ...newList];
  }, [data?.sources]);

  const toggleSources = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { checked } = event.target;
      onChange(
        checked
          ? [SOURCE_VOID.id, ...(data?.sources.map(({ id }) => id) || [])]
          : undefined,
      );
    },
    [data?.sources, onChange],
  );

  if (!data?.sources.length) {
    return null;
  }

  return (
    <div className={classes.checkboxesContainer}>
      <div className={classes.switchContainer}>
        <Typography variant="body2">Filtrer par source</Typography>
        <Switch
          checked={!!value.length}
          color="primary"
          disabled={disabled}
          onChange={toggleSources}
        />
      </div>
      {!!value.length && (
        <TreeList
          nodes={sourcesTreeList}
          checkedIds={value}
          setCheckedIds={(e) => {
            const newCheckedIds = typeof e === 'function' ? e(value) : e;
            onChange(newCheckedIds.length ? newCheckedIds : undefined);
          }}
        />
      )}
    </div>
  );
};
